"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiError = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.KpiError = function (props) {
    var message = props.message;
    return (react_1.default.createElement("span", { className: "gdc-kpi-error", style: {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontSize: "14px",
            fontWeight: 700,
            verticalAlign: "middle",
            color: "#94a1ad",
            fontFamily: "gdcustomfont, avenir, Helvetica Neue, arial, sans-serif",
        } }, message));
};
//# sourceMappingURL=KpiError.js.map